import React from 'react';
import { useRouter } from 'next/router';
import styled, { css } from 'styled-components';
import { GenericErrorScreen } from '@sparknz/journeys-common';
import { Box, Button } from '@sparknz/spark-pattern-library';

const DeviceGalleryErrorContainer = styled.div`
  ${({ theme: { media, spacing } }) => css`
    display: flex;
    gap: ${spacing.s3};
    flex-direction: column;
    width: 100%;
    ${media.up('slim')} {
      flex-direction: row;
      width: auto;
    }
  `}
`;

const DeviceGalleryError = () => {
  const router = useRouter();
  return (
    <Box py={['s5', 's9']} px={['s3', 's5']}>
      <GenericErrorScreen
        footer={
          <DeviceGalleryErrorContainer>
            <div>
              <Button variant="default" onClick={() => router.back()}>
                Back
              </Button>
            </div>
            <div>
              <Button variant="primary" onClick={() => router.reload()}>
                Try again
              </Button>
            </div>
          </DeviceGalleryErrorContainer>
        }
      />
    </Box>
  );
};

export default DeviceGalleryError;
